import React              from "react";

import Header             from '../../components/header';
import BlogFieldsModifier from './molecules/blogFieldsModifier';
import '../../app.min.css';

class RedoBlog extends React.Component {
	constructor (props) {
		super (props);
		this.state = {
			value : 0,
		};
	}

	componentDidMount () {
		document.title = "Blog Redo | Overseas.one";
		const params = new URLSearchParams (window.location.search);
		const foo = params.get ('url');
		console.log (foo);
	}

	render (props) {
		return (
			<div className = "container">
				<Header />
				<BlogFieldsModifier />
			</div>
		);
	}
}

export default RedoBlog;
